<template>
  <div
    v-if="filterStore.available.colors && filterStore.available.colors.length > 1"
    :class="$style['filter']">
    <div :class="$style['filter__title']">
      {{ $t('general/filter-color') }}

      <Btn v-if="filterStore.active.colors.length" icon-right="System/close-line" color="link" size="small" @click="filterStore.resetFilter('colors')">
        Reset filter
      </Btn>
    </div>
    <div :class="$style['filter__content']">
      <Color
        v-for="row in activeColors"
        :key="row.value"
        role="button"
        :disabled="!row.count"
        :name="row.title"
        :color="`#${row.hex}`"
        :selected="filterStore.active.colors.includes(row.value)"
        @click="filterStore.toggle({filter: 'colors',value: row.value})
        " />
    </div>
  </div>
</template>
<script setup>
const filterStore = useFilterStore()

const activeColors = computed(() => {
  return filterStore.available.colors
  // .sort((a, b) => a.count < b.count ? 1 : -1)
})

</script>
<style lang="scss" module>
@use './style' as *;

.filter {
  &__content {
    display: grid;
    grid-gap: $spacing * 2;
    grid-template-columns: repeat(4, 1fr);
    padding-bottom: $spacing * 2;
    width: 100%;
  }
}
</style>
